const a = (e) => {
  const t = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  return e.split("").map((r) => /\d/.test(r) ? t[Number(r)] : r).join("");
};
export {
  a as translateNumberToArabic
};
